import { render, staticRenderFns } from "./_Navbar-modules.vue?vue&type=template&id=ddc40984&scoped=true&"
import script from "./_Navbar-modules.vue?vue&type=script&lang=js&"
export * from "./_Navbar-modules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc40984",
  null
  
)

export default component.exports